import KumovegaError from "./KumovegaError";

export default class HTTPError extends KumovegaError {}
